import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import { cn } from "@/lib/utils";

const PageTitleBar = ({
  backTo,
  backLabel,
  icon,
  title,
  subtitle,
  actions,
  className,
}) => (
  <div className={cn("tw:flex tw:flex-col tw:gap-1.5", className)}>
    {backTo && (
      <Link
        to={backTo}
        aria-label={backLabel}
        className="tw:self-start tw:inline-flex tw:items-center tw:gap-1.5 tw:text-sm tw:no-underline tw:text-muted-foreground! tw:hover:text-foreground!"
      >
        <ArrowLeft className="tw:size-4" />
        {backLabel}
      </Link>
    )}
    <div className="tw:flex tw:items-center tw:justify-between tw:gap-3">
      <div className="tw:flex tw:items-center tw:gap-3 tw:min-w-0">
        {icon}
        <div className="tw:flex tw:flex-col tw:gap-0.5 tw:min-w-0">
          <h1
            className={cn(
              "tw:m-0 tw:font-heading tw:text-2xl tw:text-foreground",
              subtitle && "tw:m-0!"
            )}
          >
            {title}
          </h1>
          {subtitle && (
            <p className="tw:m-0 tw:text-sm tw:text-muted-foreground">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {actions && (
        <div className="tw:flex tw:items-center tw:gap-2 tw:shrink-0">
          {actions}
        </div>
      )}
    </div>
  </div>
);

export default PageTitleBar;
